import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-turns-desks-card',
  templateUrl: './turns-desks-card.component.html',
  styleUrls: ['./turns-desks-card.component.scss']
})
export class TurnsDesksCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount: any;
  disableCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('desks-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('desks-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.availableDesks;
      this.disableCount = this.data.unavailableDesks;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.disableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('desks-counts-spinner');
    }
  }
}

